import React from 'react'
import cx from 'classnames'
import useTheme from 'common/hooks/use-theme'
import styles from './index.css'

function IssuerLogo({
  light = false,
  asDialogTitle = false,
  className: customClassName
}: {
  light?: boolean
  asDialogTitle?: boolean
  className?: string
}) {
  const { [light ? 'lightLogo' : 'darkLogo']: logoUrlOrComponent } = useTheme()
  const className = cx(customClassName, { [styles.asDialogTitle]: asDialogTitle })

  if (typeof logoUrlOrComponent === 'string') {
    const url = logoUrlOrComponent
    return <img id="issuer-logo" src={url} className={cx(className, styles.imageLogo)} alt="" />
  }

  const Logo = logoUrlOrComponent
  return <Logo id="issuer-logo" className={className} />
}

export default IssuerLogo
